import {
  AttemptStats,
  SessionStatusEnum,
} from '@protos/learning_management/lms.db_pb';
import { IOptionList } from './ClickerAssessmentEndedHw/components/CAEndedHwLeftPanel';
import { Timestamp } from '@bufbuild/protobuf';
import { StudentPerformanceInfo } from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { cloneObject } from '@geneo2-web/shared-ui';

// ------------------------------------------------------------

export const createIOptionListFromAttemptStats = (
  attemptInfo?: AttemptStats[]
): IOptionList[] => {
  if (attemptInfo) {
    return attemptInfo
      .map((data, index) => {
        return {
          name: `Attempt ${data.attemptNumber}`,
          id: data.attemptNumber,
        };
      })
      .sort((a, b) => a.id - b.id);
  }

  return [
    {
      name: 'No Attempts',
      id: 0,
    },
  ];
};

// ------------------------------------------------------------

export const isTimeLeft = (endDate?: Timestamp): boolean => {
  if (!endDate) return true;
  const endDateJs = endDate.toDate();
  const now = new Date();
  return endDateJs.getTime() > now.getTime();
};

// ------------------------------------------------------------

// return last completed Attempt
export const getLastCompletedAttempt = (attempts?: AttemptStats[]) => {
  if (!attempts) return undefined;
  const validStatuses = new Set<SessionStatusEnum>([
    SessionStatusEnum.SESSION_STATUS_COMPLETED,
    SessionStatusEnum.SESSION_STATUS_ENDED_BY_SYSTEM,
    SessionStatusEnum.SESSION_STATUS_EXITED,
  ]);

  let returnVal: AttemptStats | undefined = undefined;
  for (const attempt of attempts) {
    if (validStatuses.has(attempt.attemptNumber)) {
      if (!returnVal || attempt.attemptNumber > returnVal.attemptNumber) {
        returnVal = attempt;
      }
    }
  }
  return returnVal;
};

// ------------------------------------------------------------

export const filterStudentsByPerformance = ({
  filterType,
  studentInfoList = [],
}: {
  filterType: string;
  studentInfoList?: StudentPerformanceInfo[];
}): StudentPerformanceInfo[] => {
  switch (filterType) {
    case 'EXCELLENT':
      return studentInfoList?.filter(
        (elem) => elem.isSubmitted === true && elem.scorePercent >= 70 // equals to 70 needs to be handled here
      );
    case 'AVERAGE':
      return studentInfoList?.filter(
        (elem) =>
          elem.isSubmitted === true &&
          elem.scorePercent >= 30 && // equals to 30 needs to be handled here
          elem.scorePercent < 70
      );
    case 'LOW':
      return studentInfoList?.filter(
        (elem) => elem.isSubmitted === true && elem.scorePercent < 30
      );
    case 'NOT_SUBMITTED':
      return studentInfoList?.filter((elem) => elem.isSubmitted === false);
    case 'ALL':
      return cloneObject(studentInfoList);
    default:
      return cloneObject(studentInfoList);
  }
};

// ------------------------------------------------------------
